import React from 'react'
import { ButtonSize } from '../../../components/Button/Button'
import { Color, Direction } from '../../../utils/constants'
import { FormattedMessage } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import { Link } from '../../../utils/helpers'
import ArrowButton from '../../../components/Button/variations/ArrowButton'

interface LinkCardProps {
  title: string
  link: string
  className?: string
  external?: boolean
}

const LinkCard = ({ title, className, link, external = false }: LinkCardProps) => {
    return (
        <Link
            external={external}
            to={link}
            className={twMerge(
                twMerge(
                    'py-10 md:py-16 side-padding border-black/10 bg-white h-full flex items-center',
                    className,
                ),
            )}
        >
            <div className='flex items-center justify-center md:m-auto max-w-lg gap-x-6 md:gap-x-12 lg:gap-x-16'>
                <ArrowButton
                    direction={Direction.RIGHT}
                    size={ButtonSize.MEDIUM}
                    buttonColor={Color.BLACK}
                />
                <FormattedMessage id={title}>
                    {(value) => <span className='link-card--title'>{value}</span>}
                </FormattedMessage>
            </div>
        </Link>
    )
}

export default LinkCard
